import { Check, Clear, Info, MoreHoriz } from '@mui/icons-material'
import { IconButton, ListItemIcon, Menu, MenuItem, Tooltip } from '@mui/material'
import axios from 'axios'
import { getDatabase, ref, set } from 'firebase/database'
import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2'
import MyDialog from '../../../../components/MyDialog'
import MyTable from '../../../../components/MyTable'
import { AuthStore } from '../../../../store/UserStore'
import { updateFirebasePencairan } from '../../../../utils/Firebase'
import { base_url } from '../../../../utils/GlobalVariables'
import { CustomDescrypt } from '../../../../utils/MyEncryption'

const TtdSp2d = () => {
    return (
        <div>Index</div>
    )
}

const Menux = ({data = {}, menyimpan, setMenyimpan}) => {
    const logOut = AuthStore((state) => state.logOut)
    const encryptUser = localStorage.getItem('AuthPersist');
    const encryptUserJson = JSON.parse(encryptUser);
    const decryptedUser = encryptUserJson.state.user === null ? "" : JSON.parse(CustomDescrypt(encryptUserJson.state.user));
    const [anchorEl, setAnchorEl] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [dialogData, setDialogData] = useState({});

    const openOption = Boolean(anchorEl);

    // useEffect(() => {
    //     setDialogData(data)
    // }, [data])

    const handleOption = (event) => {
        setDialogData(data)
        setAnchorEl(event.currentTarget);
        console.log(anchorEl);
    };

    const handleCloseOption = () => {
        setAnchorEl(null);
        console.log(anchorEl.event);
    };

    const handleOpenDialog = () => {
        // console.log(data);
        setDialogData(data)
        handleCloseOption();
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const onCancel = () => {
        handleCloseOption();
        Swal.fire({
            title: 'Proses SP2D Dibatalkan?',
            text: "Masukkan Catatan Revisi",
            icon: 'warning',
            input: 'text',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            showLoaderOnConfirm: true,
            confirmButtonText: 'Proses',
            cancelButtonText: 'Tutup',
            preConfirm: (revisi) => {
                const frm = {
                    _method: "PUT",
                    no_spm: dialogData.no_spm,
                    progres: 2,
                    revisi: revisi
                };
                return axios.post(
                    base_url + '/verif/pencairan/update',
                    frm,
                    {
                        headers: {
                            'Authorization': `Bearer ${decryptedUser.token}`,
                            'content-type': 'multipart/form-data'
                        }
                    })
                    .then((response) => {
                        setMenyimpan(!menyimpan)
                        updateProsesSP2D(response.data.prosesSP2D)
                        updateTtdSP2D(response.data.ttdSP2D)
                        updateFirebasePencairan(dialogData, 2)
                        return response.data
                    })
                    .catch((error) => {
                        if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                            logOut();
                        }
                        else {
                            console.log(error.response);
                            Swal.showValidationMessage(
                                `Request failed: ${error.response.statusText}`
                            )
                        }
                    })
            },
            allowOutsideClick: () => !Swal.isLoading()
        }).then((result) => {
            console.log(result);
            if (result.isConfirmed) {
                Swal.fire(
                    'Selesai!',
                    result.value.msg,
                    'success'
                )
            }
        })
    }

    const onConfirm = () => {
        handleCloseOption();
        Swal.fire({
            title: 'SP2D Diserahkan?',
            // text: "Operasi tidak dapat Dikembalikan!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            showLoaderOnConfirm: true,
            confirmButtonText: 'Ya, Lanjutkan!',
            cancelButtonText: 'Tutup',
            preConfirm: () => {
                const frm = {
                    _method: "PUT",
                    no_spm: dialogData.no_spm,
                    progres: 6
                };
                return axios.post(
                    base_url + '/verif/pencairan/update',
                    frm,
                    {
                        headers: {
                            'Authorization': `Bearer ${decryptedUser.token}`,
                            'content-type': 'multipart/form-data'
                        }
                    })
                    .then((response) => {
                        setMenyimpan(!menyimpan)
                        updateProsesSP2D(response.data.prosesSP2D)
                        updateTtdSP2D(response.data.ttdSP2D)
                        updateFirebasePencairan(dialogData, 6)
                        return response.data
                    })
                    .catch((error) => {
                        if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                            logOut();
                        }
                        else {
                            console.log(error.response);
                            Swal.showValidationMessage(
                                `Request failed: ${error.response.statusText}`
                            )
                        }
                    })
            },
            allowOutsideClick: () => !Swal.isLoading()
        }).then((result) => {
            console.log(result);
            if (result.isConfirmed) {
                Swal.fire(
                    'Selesai!',
                    result.value.msg,
                    'success'
                )
            }
        })
    }

    const updateTtdSP2D = (params) => {
        const db = getDatabase();
        set(ref(db, 'ttdSP2D'), params);
    }

    const updateProsesSP2D = (params) => {
        const db = getDatabase();
        set(ref(db, 'prosesSP2D'), params);
    }

    return (
        <>
            <Tooltip title="Pilihan">
                <IconButton aria-label="option" onClick={handleOption}>
                    <MoreHoriz />
                </IconButton>
            </Tooltip>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={openOption}
                onClose={handleCloseOption}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                <MenuItem onClick={onCancel}>
                    <ListItemIcon>
                        <Clear color='error' />
                    </ListItemIcon>
                    Batal
                </MenuItem>
                <MenuItem onClick={onConfirm}>
                    <ListItemIcon>
                        <Check color="success" />
                    </ListItemIcon>
                    SP2D Diserahkan
                </MenuItem>
                <MenuItem onClick={handleOpenDialog}>
                    <ListItemIcon>
                        <Info color="info" />
                    </ListItemIcon>
                    Info
                </MenuItem>
            </Menu>
            <MyDialog dialogData={dialogData} openDialog={openDialog} handleCloseDialog={handleCloseDialog} decryptedUser={decryptedUser} />
        </>
    )
}

const Data = () => {
    const logOut = AuthStore((state) => state.logOut)
    const encryptUser = localStorage.getItem('AuthPersist');
    const encryptUserJson = JSON.parse(encryptUser);
    const decryptedUser = encryptUserJson.state.user === null ? "" : JSON.parse(CustomDescrypt(encryptUserJson.state.user));
    const [tableData, setTableData] = useState([]);
    const [tableLoading, setTableLoading] = useState(false);
    const [menyimpan, setMenyimpan] = useState(false)


    const columns = [
        {
            field: 'action',
            headerName: '...',
            sortable: false,
            filterable: false,
            hideable: false,
            align: "center",
            headerAlign: 'center',
            disableColumnMenu: true,
            renderCell: (params) => {
                return (
                    <>
                        <Menux data={params.row} menyimpan={menyimpan} setMenyimpan={setMenyimpan} />
                    </>
                );
            }
        },
        {
            field: 'updated_at',
            headerName: 'Tanggal Update',
            filterable: false,
            hide: true
        },
        {
            field: 'created_at',
            headerName: 'Tanggal Input',
            filterable: false,
            hide: true
        },
        {
            field: 'no_spm',
            headerName: 'Nomor SPM',
            minWidth: 280,
        },
        { field: 'tgl_spm', headerName: 'Tanggal SPM' },
        {
            field: 'jenis',
            headerName: 'Jenis',
            width: 80,
            renderCell: (params) => {
                return params.row.jenis + " " + params.row.jenis_ls
            }
        },
        { field: 'keperluan', headerName: 'Keperluan', width: 430 },
        {
            field: 'anggaran',
            headerName: 'Anggaran',
            width: 150,
            renderCell: (params) => {
                return new Intl.NumberFormat("id-ID", {
                    style: "currency",
                    currency: "IDR",
                    maximumFractionDigits: 0,
                    minimumFractionDigits: 0,
                }).format(params.row.anggaran);
            }
        },
        { field: 'no_spp', headerName: 'Nomor SPP', width: 100, hide: true },
        {
            field: 'nm_opd',
            headerName: 'OPD',
            minWidth: 200,
            // type: "boolean"
        },
        {
            field: 'id_opd',
            headerName: 'ID OPD',
            hide: true
        }
    ];

    useEffect(() => {
        requestData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [menyimpan]);

    const requestData = () => {
        console.log('req data');
        setTableLoading(true)
        axios.get(
            base_url + '/verif/pencairan/ttd_sp2d',
            {
                headers: {
                    'Authorization': `Bearer ${decryptedUser.token}`
                }
            })
            .then((response) => {
                const data = response.data;
                setTableData(data.pencairan)
                setTableLoading(false)
            })
            .catch((error) => {
                if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                    logOut();
                }
            })
    }

    return (
        <>
            <MyTable
                rows={tableData}
                columns={columns}
                row_id={(row) => row.no_spm}
                isLoading={tableLoading}
            />
        </>
    )
}

export default TtdSp2d
export { Data as DataTtdSp2d }